import type TokenMetadataItem from '@/components/tokens/types/token-metadata-item.ts';
import FlexContainer from '@/components/common/flex-container';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {styledMod} from '@/utils/styled-mod.tsx';
import styles from './styles.module.css';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PushPinIcon from '@mui/icons-material/PushPin';
import IconButton from '@/components/common/icon-button';
import {useTheme} from '@mui/material';

type SwapWidgetTokensListProps = {
  activeElement: any;
  tokensMetadata: TokenMetadataItem[];
  onTokenAddressChange: (tokenAddress: string, tokenName: string, imgSrc: string) => void;
  onTokenAddressFavoritesChange: (elementSymbol: string) => void;
};

export const TokensListContainer = styledMod('ul', styles['tokens-list']);
export const TokensListItem = styledMod('li', styles['tokens-list-item']);
export const TokenLink = styledMod('a', styles['token-link']);
export const TokenSymbol = styledMod('span', styles['token-symbol']);
export const TokenInput = styledMod('input', styles['token-input']);
export const TokenLabel = styledMod('label', styles['token-label']);

export const SwapWidgetTokensList: React.FunctionComponent<SwapWidgetTokensListProps> = (
  props: SwapWidgetTokensListProps,
) => {

  const theme = useTheme();

  const onRadioInputTokenChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const element = evt.target;
    const {tokenName, tokenAddress, imgSrc} = element.dataset;
    if (tokenName && tokenAddress && imgSrc) {
      props.onTokenAddressChange(tokenName, tokenAddress, imgSrc);
    }
  };

  const onTokenAddToFavorite = (evt: any) => {
    evt.preventDefault();
    const element = evt.currentTarget;
    props.onTokenAddressFavoritesChange(element.name);
  }

  return (
    <TokensListContainer>
      {props.tokensMetadata.map((tokenElement: TokenMetadataItem, index: number) => (
        <TokensListItem key={tokenElement.symbol}>
          <TokenInput
            onChange={onRadioInputTokenChange}
            data-token-name={tokenElement.symbol}
            data-token-address={tokenElement.address}
            data-img-src={tokenElement.image}
            name="token-address"
            type="radio"
            id={tokenElement.address ?? `input-radio-${index}`}
            checked={
              props.activeElement === tokenElement.address ||
              (props.activeElement === 'TON' && tokenElement.symbol === 'TON')
            }
          />
          <TokenLabel htmlFor={tokenElement.address ?? `input-radio-${index}`}>
            <FlexContainer alignitems="center" gap={5} width={120} justifycontent="space-between">
              <img src={tokenElement.image} width={36} height={36} alt={tokenElement.symbol}/>
              <TokenSymbol>{tokenElement.symbol ?? ''}</TokenSymbol>
              <TokenLink href={`https://tonviewer.com/${tokenElement.address}`} target="_blank">
                <OpenInNewIcon/>
              </TokenLink>
            </FlexContainer>
            <FlexContainer justifycontent="space-between" width={140} alignitems="center">
              <FlexContainer transform="rotate(45deg)" justifycontent="center" alignitems="center" width={24}
                             height={24}>
                <IconButton type="button" name={tokenElement.symbol}
                            color={tokenElement.isFavorite ? theme.palette.primary.light : 'var(--disabled-color)'}
                            onClick={onTokenAddToFavorite}
                >
                  <PushPinIcon color="inherit"/>
                </IconButton>
              </FlexContainer>
              <FlexContainer alignitems="flex-end" fontSize="14px" flexdirection="column">
                <FlexContainer fontSize="16px" justifycontent="flex-end">
                  {tokenElement.balance}
                </FlexContainer>
                {tokenElement.balanceUsd && (
                  <FlexContainer justifycontent="flex-end" fontSize="16px">
                    <AttachMoneyIcon/>
                    {tokenElement.balanceUsd}
                  </FlexContainer>
                )}
              </FlexContainer>
            </FlexContainer>
          </TokenLabel>
        </TokensListItem>
      ))}
    </TokensListContainer>
  );
};
